import { Widget } from "../widget/widget";

import { SegmentWidget } from "./segment";
import { Segments } from "./segments";

const SegmentedContainer = {};
SegmentedContainer.Wrapper = Widget.Wrapper;
SegmentedContainer.Title = Widget.Title;
SegmentedContainer.Segments = Segments;
SegmentedContainer.Segment = SegmentWidget;

export { SegmentedContainer };
